import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import Page from '@app/components/layout/page/page';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { foodFilters } from '@app/sold-goods/filters';
import { useGetSoldFoodAndDrinkList } from '@shared/api/hooks/sold-goods/food-and-drink';
import { SoldGoodsFoodListParams } from '@shared/api/types';
import { parseAsString, useQueryState } from 'nuqs';
import SoldFoodAndDrinkTable from '../components/sold-food-and-drink-table';

export default function SoldFoodAndDrinkListPage() {
  const { page, perPage, sort, ...filterStates } = useDataTableQueryState({
    filters: Object.values(foodFilters).map(({ column }) => column),
  });
  const [food] = useQueryState('food', parseAsString);

  const params: SoldGoodsFoodListParams = {
    page,
    page_size: perPage,
    search: food!,
    sort: formatMultipleSortingForEndpoint(sort! || []),
  };
  // Build the API params from the table filters
  Object.values(foodFilters).forEach(({ apiKey, column }) => {
    params[apiKey] = filterStates[column];
  });

  const data = useGetSoldFoodAndDrinkList(params);

  return (
    <Page name="Food and drink" page="subpage">
      <SoldFoodAndDrinkTable {...data} />
    </Page>
  );
}
